// The password-reset link carries its one-time code in a URL fragment
// (never sent to a server) specifically so it never ends up in a log
// store. Sentry's default Breadcrumbs integration records navigation
// history including the fragment, and its UserAgent integration stamps
// event.request.url from window.location.href on every captured event.
// Both hooks below strip fragments before Sentry ever sees them, so the
// live reset code cannot ride along to sentry.io.

export const stripNavigationFragment = (crumb) => {
  if (crumb && crumb.category === 'navigation' && crumb.data) {
    crumb.data.from = String(crumb.data.from || '').split('#')[0]
    crumb.data.to = String(crumb.data.to || '').split('#')[0]
  }
  return crumb
}

export const stripRequestUrlFragment = (event) => {
  if (event && event.request && event.request.url) {
    event.request.url = event.request.url.split('#')[0]
  }
  return event
}
